import { Col, Modal, Row } from 'antd'
import Card from 'antd/es/card'
import React from 'react'
import { AiFillCloseCircle } from 'react-icons/ai'
import {
  COMPANY_LEGAL_INITIALS,
  COMPANY_LEGAL_NAME,
  COMPANY_NAME,
  COMPANY_PAN,
  TNC_BANK_DETAILS,
  TRADECRED_SUPPORT_EMAIL,
  isTradecred,
} from '../../core/constants'
import Button from '../button'
import * as styles from './TermsAndConditions.css'

export const TermsAndConditions = ({ showTNC, setShowTNC, type = 't&c' }) => {
  const WEBSITE = isTradecred ? 'www.tradecred.com' : 'buy.incomebazaar.com'

  const TermsAndConditions = (
    <Card bodyStyle={{ height: 700 }}>
      <p>
        By submitting the registration application and signing up on <b>Platform</b>, the <b>User</b> agrees to the
        following terms and conditions (hereinafter referred to as the "<b>T&Cs</b>"). These <b>T&Cs</b> shall be
        effective from the
        <b>Effective Date</b> as set out in <b>Annexure A</b>
      </p>
      <ol className={'tnc_list'}>
        <li>
          The <b>User</b>, as defined in <b>Annexure A</b> below, is desirous of executing the <b>Transactions</b> on
          online technology <b>platform</b> owned by <b>{COMPANY_NAME}</b>, which expression shall, unless repugnant to
          the context or meaning thereof, mean and include its successors-in-interest and assigns).
        </li>
        <li>
          {COMPANY_LEGAL_NAME}, having PAN {COMPANY_PAN}, owns and operates online technology <b>platform</b>{' '}
          (hereinafter referred to as "<b>{COMPANY_NAME}</b>", which expression shall, unless repugnant to the context
          or meaning thereof, mean and include its successors-in-interest and permitted assigns);
        </li>
        <li>
          <b>User</b> and <b>{COMPANY_NAME}</b> shall hereinafter be collectively referred to as "<b>Parties</b>" and
          individually as the "<b>Party</b>".
        </li>
        <li>
          "<b>Annual Maintenance Fees"</b> means annual charges levied by <b>{COMPANY_NAME}</b> on the <b>User</b> for
          administering and maintaining the <b>User Account</b> on the <b>Platform</b>.
        </li>
        <li>
          "<b>Applicable Law</b>" includes all statutes, enactments, acts of legislature or parliament, ordinances,
          rules, bye-laws, regulations, notifications, guidelines, policies, directions, directives and orders,
          requirement or other governmental restrictions or any similar form of decision of, or determination by, or any
          interpretation, policy or administration, having the force of law of any of the foregoing, of any government,
          statutory authority, tribunal, board, court having jurisdiction over the matter in question, whether in effect
          as of the <b>Effective Date</b> or any time thereafter.
        </li>
        <li>
          All references herein to Clauses and Annexures shall be deemed to be references to Clauses of, and Annexures
          to, these <b>T&Cs</b> unless the context shall otherwise require. All Annexures attached hereto shall be
          deemed incorporated herein as if set forth in full herein. The words "hereof", "herein" and "hereunder" and
          words of similar import when used in these <b>T&Cs</b> shall refer to these <b>T&Cs</b> as a whole and not to
          any particular provision of these <b>T&Cs</b>. The words "include", "includes", and "including" shall be
          deemed to be followed by the words "without limitation".
        </li>
        <li>
          Time is of the essence in the performance of the <b>Parties</b> respective obligations. If any time period
          specified herein is extended, such extended time shall also be of the essence.
        </li>
        <li>
          "<b>Confidential Information</b>" means all information (whether in written, oral, or electronic or other
          format) which relates to the operational, technical, financial and business affairs, customers, subscribers,
          lenders, borrowers, suppliers, service providers, services, developments, operations, processes, data, trade
          secrets, design rights, intellectual property, methodologies, formulae, flow charts, know-how and personnel of
          the <b>Parties</b> which is disclosed to or otherwise learnt by the receiving <b>Party</b> in the course of or
          in connection with these <b>T&Cs</b> (including without limitation such information received during
          negotiations, site visits and meetings in connection with these <b>T&Cs</b>) and that should be reasonably
          understood by the receiving <b>Party</b> to be proprietary and confidential to the discloser, or to a third{' '}
          <b>party</b>. For the sake of clarity, Confidential Information shall include these <b>T&Cs</b> and terms of
          any agreements entered between the <b>Parties</b>.
        </li>
        <li>
          "<b>Custodian</b>" means Credas Trusteeship Services Private Limited, (CIN: U74999MH2020PTC348484), a company
          incorporated under the Companies Act, 2013 who shall be the custodian in respect of the <b>Transaction</b>{' '}
          executed by the <b>User</b> and shall act in the interest of the User.
        </li>
        <li>
          "<b>Effective Date</b>" means the date on which the <b>User</b> is successfully registered on the{' '}
          <b>Platform</b>. The
          <b>User</b> shall be successfully registered on the <b>Platform</b> on creation of the <b>User Account/s</b>,
          successful completion of the due diligence of the <b>User</b> and on the <b>User</b> agreeing to these{' '}
          <b>T&Cs</b>.
        </li>
        <li>
          "<b>Governmental Authority</b>" includes any nation or government, any state or other political subdivision
          thereof; any entity, authority or body exercising executive, legislative, judicial, regulatory or
          administrative functions of or pertaining to any government, including any government authority, agency,
          department, board, commission or instrumentality of any nation or any political subdivision thereof; any
          court, tribunal or arbitrator; and any self- regulatory organization; and includes the Securities and Exchange
          Board of India, recognized stock exchanges or quotation systems, and the Reserve Bank of India.
        </li>
        <li>
          "<b>Governmental Approval</b>" means any consent, permission, approval, permit with, to, from or by any
          Governmental Authority.
        </li>
        <li>
          "<b>Platform</b>" means online technology <b>platform</b> owned and operated by <b>{COMPANY_NAME}</b> through
          its website
          <b>{WEBSITE}</b> including its sub-domains and <b>{COMPANY_NAME}</b> mobile application.
        </li>
        <li>
          "<b>Transaction</b>" or "<b>Transactions</b>" means any <b>transaction</b> executed by the participants on the{' '}
          <b>Platform</b> in accordance of the <b>Transaction Agreement</b> and these <b>T&Cs</b>.
        </li>
        <li>
          "<b>Transaction Agreement</b>" means the agreement executed by the <b>User</b>, other participants on the{' '}
          <b>Platform</b>
          and any other entity/s for the purpose of execution of the <b>Transactions</b> on the <b>Platform</b>.
        </li>
        <li>
          "<b>User Account/s</b>" means the virtual code allocated to the <b>User</b> and which is linked to the{' '}
          <b>User</b> Escrow Account/s, the details of which are mentioned in <b>Annexure A</b>.
        </li>
        <li>
          "<b>User</b> Escrow Account/s" means the escrow account/s opened with banks as specified in <b>Annexure A</b>{' '}
          and operated by <b>{COMPANY_NAME}</b> to manage the funds of the <b>User</b>.
        </li>
        <li>
          The <b>User</b> hereby agrees to register on the <b>Platform</b> as a <b>user</b>, in accordance with these{' '}
          <b>T&Cs</b>.
        </li>
        <li>
          The <b>User</b> shall, in consideration of <b>{COMPANY_NAME}</b> facilitating the <b>Transactions</b> and
          usage of the
          <b>Platform</b>, pay to <b>{COMPANY_NAME}</b> any fees as may be applicable and levied by{' '}
          <b>{COMPANY_NAME}</b>.
        </li>
        <div>
          <b>REPRESENTATIONS, WARRANTIES AND COVENANTS</b>
        </div>
        <li>
          For the sake of clarification, <b>{COMPANY_NAME}</b> is merely an administrator facilitating the{' '}
          <b>Transaction</b> and does not have any beneficial interest in the <b>Transaction</b>, except to the extent
          of any fees payable to <b>{COMPANY_NAME}</b>.
        </li>
        <li>
          <b>{COMPANY_NAME}</b> is not underwriting/ guaranteeing the performance of the obligations by the participants
          on the <b>Platform</b> and any other entity/s which are <b>party</b> to the <b>Transaction Agreement</b>{' '}
          executed by the
          <b>User</b>. Further, <b>{COMPANY_NAME}</b> shall not be required to provide any security/ undertakings to the{' '}
          <b>User</b>
          pertaining to any <b>Transaction</b>.
        </li>
        <li>
          The registration of the <b>User</b> on the <b>Platform</b> shall be subject to the fulfilment by the{' '}
          <b>User</b> of the due diligence, to the sole satisfaction of <b>{COMPANY_NAME}</b>. The <b>User</b> hereby
          agrees to provide to <b>{COMPANY_NAME}</b>
          all such forms, reports, documents, Governmental Approvals, agreements and other documents, as
          <b>{COMPANY_NAME}</b> may require from time to time, for the conduct of the due diligence on the <b>User</b>.
        </li>
        <li>
          The continued registration of the <b>User</b> on the <b>Platform</b> shall be subject to the <b>User</b>{' '}
          fulfilling the due diligence requirements of <b>{COMPANY_NAME}</b>. <b>{COMPANY_NAME}</b> shall have the right
          to call upon the <b>User</b>, subsequent to the registration, to submit such documents as it may reasonably
          require to satisfy itself that the <b>User</b> is entitled to continue to be registered on the <b>Platform</b>
          . It is hereby expressly clarified that <b>{COMPANY_NAME}</b> shall be entitled to terminate the registration
          of the <b>User</b> on the <b>Platform</b> in accordance with these <b>T&Cs</b> in the event{' '}
          <b>{COMPANY_NAME}</b> is of the opinion that the <b>User</b>
          fails to satisfy the requirements for registration.
        </li>
        <li>
          Simultaneous with agreeing to these <b>T&Cs</b>, the <b>User</b> agrees to open the <b>User Account/s</b>. For
          the sake of clarification, these <b>T&Cs</b> shall not come into effect unless the <b>User Account/s</b> is
          created.
        </li>
        <li>
          The <b>User</b> agrees to transfer the requisite monies to the <b>User Account/s</b> for the purpose of
          executing the <b>Transactions</b>. The <b>User</b> also agrees to <b>{COMPANY_NAME}</b> acting as an
          administrator with respect to the settlement of monies between the <b>parties</b> to the{' '}
          <b>Transaction Agreement</b> as per the terms and condition of the <b>Transaction Agreement</b> and these{' '}
          <b>T&Cs</b>.
        </li>
        <li>
          The <b>User</b> agrees and undertakes that any monies transferred to the <b>User Account/s</b> belongs to the
          <b>User</b> and is from the <b>User's</b> wealth or income. The <b>User</b> agree and undertakes to inform{' '}
          <b>{COMPANY_NAME}</b> in case any money transferred to the <b>User Account/s</b> does not belong to the{' '}
          <b>User</b> and the <b>User</b> shall not use any such monies is the <b>User Account/s</b> for transaction or
          withdrawal.
        </li>
        <li>
          The <b>User</b> agrees and undertakes that the <b>User Account/s</b> may not be closed without the prior
          written consent of <b>{COMPANY_NAME}</b>. Further, in the event the <b>User</b> is desirous of withdrawing any
          amount from the <b>User Account/s</b>, the <b>User</b> shall submit a request for such withdrawal on the
          <b>Platform</b>.
        </li>
        <li>
          The <b>User</b> agrees and undertakes that before any withdrawal requests are placed on the <b>Platform</b>{' '}
          the <b>User</b> shall ensure <b>User's</b> Bank account is correctly updated on the <b>Platform</b> and{' '}
          <b>{COMPANY_NAME}</b> shall not be held responsible for withdrawals processed in any incorrect Bank accounts
          mentioned in the <b>User's</b> profile on the <b>platform</b>.
        </li>
        <li>
          The <b>User</b> undertakes to not do or cause to be done any act whereby or by reason whereof the reputation
          and goodwill of <b>{COMPANY_NAME}</b> is adversely affected in any manner whatsoever.
        </li>
        <li>
          The <b>User</b> undertakes to fulfil its obligations under these <b>T&Cs</b> and the{' '}
          <b>Transaction Agreements</b> in a timely, diligent, competent and professional manner and also observe and
          conform to standards of business ethics and honest business practices.
        </li>
        <li>
          The <b>User</b> shall ensure that it is compliant with the provisions of the <b>Applicable Law</b>, including
          but not limited to the Prevention of Money Laundering Act, 2002 and the Factoring Regulation Act, 2011.
          Further, the <b>User</b> shall ensure that it, at all times, conforms to <b>Applicable Law</b>. In the event
          the
          <b>User</b> fails to comply with any <b>Applicable Law</b>, <b>{COMPANY_NAME}</b> shall have the right to
          terminate the registration of the <b>User</b> on the <b>Platform</b> in accordance with these <b>T&Cs</b>.
        </li>
        <li>
          The <b>User</b> shall not issue any external communications, concerning these <b>T&Cs</b> or the{' '}
          <b>Transaction</b>
          Agreements, any of the activities contemplated by these <b>T&Cs</b> or the <b>Transaction Agreements</b>; or
          the relationship between the <b>User</b> and <b>{COMPANY_NAME}</b>, without the prior written consent of{' '}
          <b>{COMPANY_NAME}</b>, which consent shall not be unreasonably withheld. External communications shall
          include, without limitation, press releases, advertisements, articles appearing in any form of media, the{' '}
          <b>User’s</b>
          website, as the case may be or other public announcements.
        </li>
        <li>
          The <b>User</b> hereby represents and warrants that they have full power, capacity and authority to execute,
          deliver and perform obligations under these <b>T&Cs</b> and have taken all necessary action (corporate,
          statutory or otherwise) to execute and authorize the execution, delivery and performance of obligations under
          these <b>T&Cs</b>.
        </li>
        <li>
          The <b>User</b> hereby represents and warrants that obligations under these <b>T&Cs</b> has been duly and
          validly accepted and agreed by the <b>User</b> and that these <b>T&Cs</b> constitutes a legal and binding
          obligation of the <b>User</b> enforceable against the <b>User</b> in accordance with these <b>T&Cs</b>.
        </li>
        <li>
          The <b>User</b> hereby represents and warrants that to the best of their knowledge, there are no legal,
          quasi-legal, administrative, arbitration, mediation, conciliation or other proceedings, claims, actions,
          governmental investigations, orders, judgments or decrees of any nature made, existing, threatened,
          anticipated or pending against such <b>Party</b> or any obligation, act, omission or
          <b>transaction</b> contemplated hereunder.
        </li>
        <li>
          Any notices to be sent by the <b>User</b> to <b>{COMPANY_NAME}</b> or vice-versa in connection with these{' '}
          <b>T&Cs</b> shall be in writing and shall be sent to the e-mail address provided at the time of registration,
          addressed to the authorized representative of the <b>User</b> or <b>{COMPANY_NAME}</b>. For the sake of
          clarification, any notice regarding any amendment to these <b>T&Cs</b> may be provided to the <b>User</b> to
          the registered e-mail address of the <b>User</b>.
        </li>
        <li>
          The <b>User</b> agrees and understands that <b>{COMPANY_NAME}</b> holds the right to modify these Terms and
          Conditions from time to time with or without notification to the <b>Users</b> and the <b>User</b> shall abide
          by the revised Terms and Conditions. The <b>User</b> understands that the <b>User</b> can review the T&Cs
          anytime in User’s profile on the platform
        </li>
        <li>
          The <b>User</b> hereby agree that affixing the digital signatures of the <b>User</b> on these <b>T&Cs</b>,
          which is generated by <b>{COMPANY_NAME}</b> owned domain website <b>{WEBSITE}</b>, with <b>{COMPANY_NAME}</b>{' '}
          logo affixed onto this shall constitute valid consent and create binding obligations on the <b>User</b> under
          these <b>T&Cs</b>.
        </li>
        <li>
          If any provision of these <b>T&Cs</b> is held to be illegal, invalid, or unenforceable under any present or
          future <b>Applicable Law</b>, and if the rights and obligations of the <b>User</b> and <b>{COMPANY_NAME}</b>{' '}
          are not affected, (a) such provision under these <b>T&Cs</b> shall be fully severable; (b) these <b>T&Cs</b>{' '}
          shall be construed and enforced as if such illegal, invalid, or unenforceable provision had never comprised a
          part hereof; and, (c) the remaining provisions of these <b>T&Cs</b> shall remain in full force and effect and
          shall not be affected by the illegal, invalid, or unenforceable provision or by its severance here from.
          Without prejudice to the foregoing, <b>{COMPANY_NAME}</b> shall provide a legal, valid and enforceable
          provision similar in terms and effect to such illegal, invalid or unenforceable provision as may be possible.
        </li>
      </ol>
      <div>
        <b>TERMINATION</b>
      </div>
      <ol className={'tnc_list'}>
        <li>
          {' '}
          Any <b>Party</b> may terminate the registration of the <b>User</b> on the <b>Platform</b> without cause by
          providing a prior written notice of 15 (fifteen) working days to the other <b>Party</b>. On termination of the
          registration of the <b>User</b> on the <b>Platform</b> these <b>T&Cs</b> shall cease to be effective.
        </li>
        <li>
          {' '}
          The registration of the <b>User</b> on the <b>Platform</b> shall be terminated and these <b>T&Cs</b> shall
          cease to be effective with immediate effect in the event any <b>Party</b> hereto is declared bankrupt or
          becomes the subject of proceedings for bankruptcy, dissolution or liquidation, or is unable to pay its debts
          and liabilities as they become due and a petition for winding up such <b>Party</b> is admitted by a court of
          competent jurisdiction and a provisional liquidator or liquidator is appointed by such court with respect to
          such <b>Party</b>.
        </li>
        <li>
          {' '}
          Each <b>Party</b> shall indemnify, defend the other <b>Party</b>, its employees, directors, shareholders and
          affiliates and shall always keep and hold such other <b>Party</b> harmless against any liabilities, costs,
          charges, expenses (including reasonable attorney fees), claims, demands, actions, direct damages or losses of
          any nature whatsoever which may, at any time, be incurred or suffered by or imposed on such other <b>Party</b>{' '}
          as a result of any breach by the <b>Party</b> of these <b>T&Cs</b> and any terms of the
          <b>Transaction Agreements</b>. It is hereby expressly clarified that the <b>User</b> shall indemnify{' '}
          <b>{COMPANY_NAME}</b>, its employees, directors, shareholders and affiliates in the event of any claims,
          damages or losses incurred by <b>{COMPANY_NAME}</b> as a result of non-compliance of the <b>User</b> with any{' '}
          <b>Applicable Law</b> and breach of these <b>T&Cs</b> and terms and conditions of the{' '}
          <b>Transaction Agreements</b>.
        </li>
      </ol>
      <div>
        <b>DISPUTE RESOLUTION AND ARBITRATION</b>
      </div>
      <ol className={'tnc_list'}>
        <li>
          These <b>T&Cs</b> shall be governed by and construed in accordance with the laws of India.
        </li>
        <li>
          The <b>User</b> and <b>{COMPANY_NAME}</b> both agrees to negotiate in good faith to resolve any dispute
          between them arising out of or relating to these <b>T&Cs</b>.
        </li>
        <li>
          Any dispute arising from and out of any of these <b>T&Cs</b>, without regard to the principles of conflict of
          laws shall be entertained and tried in the courts of Mumbai alone and no other courts shall have the
          jurisdiction.
        </li>
        <li>
          All Disputes that cannot be satisfactorily resolved between the <b>User</b> and <b>{COMPANY_NAME}</b> shall be
          referred to and finally resolved by arbitration in Mumbai in accordance with the Indian Arbitration Act for
          the time being in force, which rules are deemed to be incorporated by reference in this clause. There shall be
          a sole arbitrator who shall be appointed by <b>{COMPANY_NAME}</b> to the dispute. The seat of the arbitration
          shall be Mumbai and the venue may be as determined by the arbitrator from time to time having regard to the
          convenience of the <b>User</b> and <b>{COMPANY_NAME}</b>. The language of the arbitration shall be English.
          The arbitrator shall make an award in writing within 60 (sixty) working days of the reference of the dispute
          to arbitration. The award of the arbitrator(s) shall be final and conclusive and binding upon the <b>User</b>{' '}
          and <b>{COMPANY_NAME}</b> and non-appealable to the extent permitted by
          <b>Applicable Law</b>. The provisions of this Clause shall survive even after the termination of the
          registration of the <b>User</b> on the <b>Platform</b> and these <b>T&Cs</b> cease to be effective.
        </li>
      </ol>
      <br />
      <Row>
        <Col span={12}>
          <p>
            <b>Agreed to by User</b>
          </p>
          <p>
            <b>Name:</b>
          </p>
          <p>
            <b>Authorised Signatory</b>
          </p>
          <p>
            <b>Date:</b>
          </p>
        </Col>
      </Row>
      <br />
      <br />
      <div className={styles.subTitle}>
        <span>
          <b>ANNEXURE A</b>
        </span>
      </div>
      <div>
        <p>
          <b>User Name:</b>
        </p>
        <p>
          <b>User PAN:</b>
        </p>
        <p>
          <b>User Account Number:</b>
        </p>
        <p>
          <b>User Account IFSC:</b> IDFB0040101
        </p>
        <p>
          <b>User Bank:</b> IDFC First Bank Limited
        </p>
        {TNC_BANK_DETAILS.map((details, i) => (
          <p key={i}>
            <b>{details[0]} :</b> {details[1]}
          </p>
        ))}
        <p />
        <p>
          <b>
            <b>Effective Date</b>:
          </b>
        </p>
      </div>
    </Card>
  )

  const PrivacyPolicy = (
    <Card bodyStyle={{ height: 700 }}>
      <div>
        <br />
        {COMPANY_NAME} is a trademark licensed to {COMPANY_LEGAL_NAME}. {COMPANY_LEGAL_NAME} is authorised to own and/or
        operate this website with the name {WEBSITE}.
        <br />
        <br />
        <b>1. Introduction</b>
        <br />
        <br /> We, at {COMPANY_LEGAL_NAME} and our affiliated companies worldwide (hereinafter collectively referred to
        as "{COMPANY_LEGAL_INITIALS}"), are committed to respecting your online privacy and recognize the need for
        appropriate protection and management of any personally identifiable information you share with us. This Privacy
        Policy ("<b>Policy</b>
        ") describes how {COMPANY_LEGAL_INITIALS} collects, uses, discloses and transfers personal information of users
        through its websites and applications, including through
        {WEBSITE}, mobile applications and online services (collectively, the "Platform"). This policy applies to those
        who visit the Platform, or whose information {COMPANY_LEGAL_INITIALS} otherwise receives in connection with its
        services (such as contact information of individuals associated with {COMPANY_LEGAL_INITIALS} including
        partners) (hereinafter collectively referred to as "Users"). For the purposes of the Privacy Policy, "<b>You</b>
        " or "<b>Your</b>" shall mean the person who is accessing the Platform. <br />
        <br />
        <b>2. Types of Personal Information collected by {COMPANY_LEGAL_INITIALS}</b>
        <br />
        <br /> "Personal information" (PI) - means any information relating to an identified or identifiable natural
        person including common identifiers such as a name, an identification number, location data, an online
        identifier or one or more factors specific to the physical, physiological, genetic, mental, economic, cultural
        or social identity of that natural person and any other information that is so categorized by applicable laws.
        We collect information about you and/or your usage to provide better services and offerings. The Personal
        Information that we collect, and how we collect it, depends upon how you interact with us. We collect the
        following categories of Personal Information in the following ways: <br />
        <br />
        <ul>
          <li>
            name, email address, password, country, city, contact number and company/organization that you are
            associated with, when the you sign up for either deploying your funds or getting funded for your assets on
            the Platform;
          </li>
          <li>information that one would usually include in a KYC documents when you register on the Platform;</li>
          <li>
            information about the services that you use and how you use them, including log information and location
            information, when you are a user of the services through the Platform;
          </li>
          <li>
            we may collect your Personal Information such as name, age, contact details, preferences, etc. through
            surveys and forms, when you choose to participate in these surveys etc.;
          </li>
          <li>
            we may also collect information relating to your caste and information about whether you are eligible for
            any affirmative action programmes or policies, if you opt to provide such information;
          </li>
          <li>
            when you communicate with {COMPANY_LEGAL_INITIALS} or use the Platform to communicate with other Users (such
            as partners), we collect information about your communication and any information you choose to provide;
          </li>
          <li>
            when you visit the Platform, we use cookies to automatically collect, store and use technical information
            about your system and interaction with our Platform;
          </li>
          <li>
            when you use a device to access the Platform, {COMPANY_LEGAL_INITIALS} may collect technical or other
            related information from the device as well as the device location;
          </li>
          <li>
            If you choose to sign in with your social media account to access the Platform, or otherwise connect your
            social media account with the services of the Platform, you consent to our collection, storage, and use, in
            accordance with this Privacy Policy, of the information that you make available to us through the social
            media interface. Please see your social media provider's privacy policy and help centre for more information
            about how they share information when you choose to connect your account.
          </li>
        </ul>
        <b>3. How {COMPANY_LEGAL_INITIALS} may use your Personal Information</b>
        <br />
        <br /> We will only use your personal data in a fair and reasonable manner, and where we have a lawful reason to
        do so. <br />
        <br /> Our use of your personal data depends on the purpose for which you interact with us. We may process your
        Personal Information for the following purposes:
        <ul>
          <li>
            Providing our services and products to you including to send you notifications of purchase, deal investment,
            (as the case maybe);
          </li>
          <li>Protecting our Users and providing you with customer support;</li>
          <li>
            We use information collected from cookies and other technologies, to improve your user experience and the
            overall quality of our services (for more information please refer to paragraph 4 below). When showing you
            tailored ads, we will not associate an identifier from cookies or similar technologies with sensitive
            categories, such as those based on race, religion, sexual orientation or health.
          </li>
          <li>Improving the Platform and its content to provide better features and services.</li>
          <li>Conducting market research and surveys with the aim of improving our products and services.</li>
          <li>Sending you information about our products and services for marketing purposes and promotions;</li>
          <li>
            Preventing, detecting, investigating and taking action against crimes (including but not limited to fraud
            and other financial crimes), any other illegal activities, suspected fraud, or violations of{' '}
            {COMPANY_LEGAL_INITIALS}’s Terms of Use in any jurisdiction
          </li>
          <li>
            To the extent required for identity verification, government sanctions screening and due diligence checks.
          </li>
          <li>
            Establishing, exercising or defending legal rights in connection with legal proceedings (including any
            prospective legal proceedings) and seeking professional or legal advice in relation to such legal
            proceedings.
          </li>
        </ul>
        <b>4. Cookies and Other Tracking Technologies</b>
        <br />
        <br /> Some of our web pages utilize "cookies" and other tracking technologies. A "cookie" is a small text file
        that may be used, for example, to collect information about web-site activity. Some cookies and other
        technologies may serve to recall Personal Information previously indicated by a user. Most browsers allow you to
        control cookies, including whether or not to accept them and how to remove them. <br />
        <br /> You may set most browsers to notify you if you receive a cookie, or you may choose to block cookies with
        your browser, but please note that if you choose to erase or block your cookies, you will need to re-enter your
        original user ID and password to gain access to certain parts of the Platform. <br />
        <br /> Tracking technologies may record information such as Internet domain and host names; Internet protocol
        (IP) addresses; browser software and operating system types; clickstream patterns; and dates and times that our
        site is accessed. Our use of cookies and other tracking technologies allows us to improve our Platform and the
        overall website experience. We may also analyse information that does not contain Personal Information for
        trends and statistics. <br />
        <br /> For more information about our use of cookies please refer to our{' '}
        <a href='#cookiePolicy'>Cookie Policy</a>. <br />
        <br />
        <b>5. The Basis/ Grounds which we rely on for collection and processing of your Personal Information:</b>
        <br />
        <br /> Your Personal Information is collected and processed by {COMPANY_LEGAL_INITIALS} based on the following
        legal grounds depending upon the nature of Personal Information and the purposes for which it is processed.
        <ul>
          <li>
            <b>Consent:</b>
            <br />
            <br /> {COMPANY_LEGAL_INITIALS} relies on your consent in order to process your Personal Information in
            certain situations. If
            {COMPANY_LEGAL_INITIALS} requires your consent to collect and process certain Personal Information, as per
            the requirements under the applicable data protection laws, your consent is sought at the time of collection
            of your Personal Information and such processing will only be performed where consent is secured. <br />
            <br />
          </li>
          <li>
            <b>Compliance with a legal obligation:</b>
            <br />
            <br /> Your Personal Information may be processed by {COMPANY_LEGAL_INITIALS}, to the extent that such
            processing is necessary to allow {COMPANY_LEGAL_INITIALS} to comply with a legal obligation. An example of
            this would be if {COMPANY_LEGAL_INITIALS} is required to disclose your Personal Information to respond to a
            court order or if {COMPANY_LEGAL_INITIALS} is required to retain specific records for a fixed period to
            comply with requirements under any applicable law.
          </li>
        </ul>
        <b>6. Information Sharing and Disclosure</b>
        <br />
        <br /> We restrict access to your Personal Information to employees who we believe reasonably need to know/or
        that information to fulfil their jobs to provide, operate, develop, or improve our products or services. <br />
        <br /> {COMPANY_LEGAL_INITIALS} does not disclose, transfer or share your Personal Information with others
        except with:
        <ul>
          <li>
            Our affiliates and group companies to the extent required for our internal business and/or administrative
            purposes and/or general corporate operations and for provision of services;
          </li>
          <li>
            Third parties including enforcement, regulatory and judicial authorities, if we determine that disclosure of
            your Personal Information is required to a) respond to subpoenas, court orders, or legal process, or to
            establish or exercise our legal rights or defend against legal claims; or b) investigate, prevent, or take
            action regarding illegal activities, suspected fraud, situations involving potential threats to the physical
            safety of any person, violations of {COMPANY_LEGAL_INITIALS}’s Terms of Use or as otherwise required by law;
          </li>
          <li>
            In the event of a merger, acquisition, financing, or sale of assets or any other situation involving the
            transfer of some or all of {COMPANY_LEGAL_INITIALS}’s business assets we may disclose Personal Information
            to those involved in the negotiation or transfer.
          </li>
          <li>
            Third party service providers and marketing partners that {COMPANY_LEGAL_INITIALS} engages to a) provide
            services over the Platform on {COMPANY_LEGAL_INITIALS}’s behalf; b) maintain the Platform and mailing lists;
            or c) communicate with you on
            {COMPANY_LEGAL_INITIALS}’s behalf about offers relating to its products and/or services.{' '}
            {COMPANY_LEGAL_INITIALS} will take reasonable steps to ensure that these third-party service providers are
            obligated to protect your Personal Information and are also subject to appropriate confidentiality /
            non-disclosure obligations.
          </li>
          <li>
            Third party advertisers to display advertisements to you when you visit the Platform. The third-party
            advertisers include financial service providers (such as banks, insurance agents, stock brokers and mortgage
            lenders) and non-financial companies (such as stores, airlines, and software companies). These companies may
            use information about you and your visits to this Platform and other web sites to provide advertisements on
            this Platform.
          </li>
        </ul>
        The Company does not provide any Personal Information to the advertiser when you interact with or view a
        targeted advertisement. However, if you interact with or view an advertisement, the advertiser may make certain
        assumptions and, in the process, learn certain Personal Information about you. For instance, if you view and
        click an advertisement that is targeted towards women in the age group 18- 24 from a specific geographic area,
        the advertiser may assume that you meet the relevant criteria. <br />
        <br /> {COMPANY_LEGAL_INITIALS} does not intend to transfer Personal Information without your consent to third
        parties who are not bound to act on {COMPANY_LEGAL_INITIALS}'s behalf unless such transfer is legally required.{' '}
        <br />
        <br /> If your Personal Information is transferred outside India, we take the necessary steps to protect your
        Personal Information in accordance with applicable data protection laws. <br />
        <br />
        <b>7. Third Party Content:</b>
        <br />
        <br /> Please be aware that the Platform sometimes contains links to other sites that are not governed by this
        Privacy Policy. Users may be directed to third-party sites for more information, such as advertisers, blogs,
        content sponsorships, vendor services, social networks, etc. <br />
        <br /> {COMPANY_LEGAL_INITIALS} makes no representations or warranties regarding how your information is stored
        or used on third-party servers. We recommend that you review the applicable privacy statements and policies of
        each third-party site linked from the Platform to determine their use of your personal information. <br />
        <br />
        <b>8. Children</b>
        <br />
        <br /> To use the Platform, you agree that you must be the minimum age (described in this paragraph below) or
        older. <br />
        <br /> The minimum age for these purposes shall be eighteen (18), however if local laws require that you must be
        older for {COMPANY_LEGAL_INITIALS} to be able to lawfully provide the services over the Platform to you then
        that older age shall apply as the applicable minimum age. <br />
        <br /> If you are under the age of 18 or the age of majority in your jurisdiction, you must use the Platform
        under the supervision of your parent, legal guardian or responsible adult. <br />
        <br />
        <b>9. Retention of Personal Information</b>
        <br />
        <br /> Your Personal Information will not be retained by {COMPANY_LEGAL_INITIALS} any longer than it is
        necessary for the purposes for which the Personal Information is processed and/or in accordance with legal,
        regulatory, contractual or statutory obligations as applicable. <br />
        <br /> At the expiry of such periods, your Personal Information will be deleted or archived in compliance with
        applicable laws <br />
        <br />
        <b>10. Controlling your personal information</b>
        <br />
        <br /> You have the right to invoke your rights which are available to data principals or data subjects (as per
        applicable laws and regulations) in relation to your Personal Information which is being processed by{' '}
        {COMPANY_LEGAL_INITIALS}. <br />
        <br /> {COMPANY_LEGAL_INITIALS} provides you the ability to keep your Personal Information accurate and
        up-to-date. If at any time you would like to a) rectify, update or correct your Personal Information; b) obtain
        confirmation on whether or not your Personal Information is processed by it; c) access your Personal Information
        or exercise your right to data portability; or d) exercise your right to restrict the continuing disclosure of
        your Personal Information to any third party by {COMPANY_LEGAL_INITIALS} in certain circumstances, you are
        requested to contact us using the contact details mentions in paragraph 15 below. We will require you to provide
        a valid proof of your identity, in order to ensure that your rights are respected. <br />
        <br /> For the exercise of certain rights, you may be required to approach the relevant authority / designated
        officer as per the provisions of the applicable data protection laws/ {COMPANY_LEGAL_INITIALS} may in accordance
        with the provisions of applicable data protection laws, charge a fee for fulfilling your request, in particular
        in case of excessive or manifestly unfounded request. Further you acknowledge that the abovementioned rights are
        not absolute and are subject to limitations as per the applicable data protection laws. <br />
        <br />
        <b>10. Confidentiality and Security</b>
        <ul>
          <li>
            The security and confidentiality of your Personal Information is important to us and{' '}
            {COMPANY_LEGAL_INITIALS} has invested significant resources to protect the safekeeping and confidentiality
            of your personal data. When using external service providers acting as processors, we require that they
            adhere to the same standards as {COMPANY_LEGAL_INITIALS}
            does. Regardless of where your Personal Information is transferred or stored, we take all steps reasonably
            necessary to ensure that personal data is kept secure.
          </li>
          <li>
            We seek to ensure compliance with the requirements of the Information Technology Act, 2000 and Rules made
            there under to ensure the protection and preservation of your privacy. We have physical, electronic, and
            procedural safeguards that comply with the laws prevalent in India to protect your Personal Information. By
            accepting the terms of this Privacy Policy, you agree that the standards and practices being implemented by
            us, are reasonable and sufficient for the protection of your Personal Information.
          </li>
        </ul>
        <b>11. Social media</b>
        <br />
        <br /> {COMPANY_LEGAL_INITIALS} operates channels, pages and accounts on some social media sites to inform,
        assist and engage with customers. {COMPANY_LEGAL_INITIALS} monitors and records comments and posts made on these
        channels about itself in order to improve its products and services. <br />
        <br /> Please note that you must not communicate the following information to {COMPANY_LEGAL_INITIALS} through
        such social media sites: <br />
        <br /> - sensitive personal data including (i) special categories of personal data meaning any information
        revealing racial or ethnic origin, political opinions, religious or philosophical beliefs, or trade union
        membership, and the processing of genetic data, biometric data for the purpose of uniquely identifying a natural
        person, data concerning health or data concerning a natural person's sex life or sexual orientation and (ii)
        other sensitive personal data such as criminal convictions and offences and national identification number ; -
        Excessive, inappropriate, offensive or defamatory content. {COMPANY_LEGAL_INITIALS} is not responsible for any
        information posted on those sites other than the information posted by its employees on its behalf.{' '}
        {COMPANY_LEGAL_INITIALS} is only responsible for its own use of the Personal Information received through such
        sites. <br />
        <br />
        <b>12. Changes to this Privacy Policy</b>
        <br />
        <br /> {COMPANY_LEGAL_INITIALS} reserves the right to update, change or modify this Privacy Policy at any time.
        The Privacy Policy shall come to effect from the date of publication of such update, change or modification.{' '}
        <br />
        <br />
        <b>13. Disclaimer</b>
        <br />
        <br /> {COMPANY_LEGAL_INITIALS} does not store any account related information or any credit / debit card
        details. {COMPANY_LEGAL_INITIALS} shall not be liable for any loss or damage sustained by Users as a result of
        any disclosure (inadvertent or otherwise) of any information concerning the User's account, credit cards or
        debit cards in the course of any online transactions or payments made for any products and/or services offered
        through the Platform. <br />
        <br /> In case any Personal Information is shared by you with {COMPANY_LEGAL_INITIALS}, which is not requested
        by {COMPANY_LEGAL_INITIALS} during registration, (whether mandatorily or optionally), {COMPANY_LEGAL_INITIALS}{' '}
        will not be liable for any information security breach or disclosure in relation to such information. <br />
        <br /> If you have any questions regarding this Privacy Policy or the protection of your Personal Information,
        please contact {COMPANY_LEGAL_INITIALS}’s Data Protection Officer/ Grievance Officer at the following:
        <br />
        <br />
        <b>14. Data Protection Officer/ Grievance Officer</b>
        <br />
        <br /> In case you have any complaints and/or grievances in relation to the processing of your Personal
        Information you can send your complaints via e-mail to our grievance officer: <br />
        <br /> Grievance Officer
        <br /> {COMPANY_LEGAL_NAME}
        <br />
        9th Floor, H 905, Premier Residencies <br />
        Kirol Road, Kurla West,
        <br />
        Mumbai
        <br /> Email: <a href={`mailto:${TRADECRED_SUPPORT_EMAIL}`}>{TRADECRED_SUPPORT_EMAIL}</a>
        <br />
      </div>
      <h3>Cookie Policy</h3>
      <div>
        <b>Introduction</b>
        <br />
        <br /> This Cookie Policy ("Policy") explains that we believe in being open and clear about how we use your
        information. In the spirit of transparency, this Policy provides detailed information about how and when we use
        cookies on our Websites. This cookie policy applies to any {WEBSITE} product or service that links to this
        policy or incorporates it by reference. <br />
        <br />
        <b>a. Does {WEBSITE} uses cookies?</b>
        <br />
        <br /> {WEBSITE} uses cookies, tags and other technologies when you use any of the {WEBSITE}
        websites, mobile sites or mobile apps (collectively "the services"). Cookies are used to ensure everyone has
        their best possible experience. Cookies also help us keep your account safe. By continuing to visit or use our
        services, you are agreeing to the use of cookies and similar technologies for the purposes we describe in this
        policy. If you prefer not to receive cookies or web beacons, then you should stop using our site, or consult
        your browsing and third party cookie settings as described below. <br />
        <br />
        <b>b. What is a cookie?</b>
        <br />
        <br /> Cookies are small pieces of text stored by a website you visit in your browser and subsequently sent by
        your web browser in every request to the website. A cookie file is stored in your web browser and allows the
        Site or a third-party to recognize you and make your next visit easier and the Site more useful to you.
        Essentially, cookies are a user’s identification card for the {WEBSITE} servers. Cookies allow {WEBSITE} to
        serve you better and more efficiently, and to personalize your experience on our site. Web beacons, tags and
        scripts may be used in the Websites or in emails to help us to deliver cookies, count visits, understand usage
        and campaign effectiveness and determine whether an email has been opened and acted upon. We may analyse or
        perform analysis based on the use of these technologies and generate reports on an individual and aggregated
        basis. <br />
        <br /> Cookies can be "persistent" or "session" cookies. A persistent cookie helps us recognize you as an
        existing user, so it’s easier to return to {WEBSITE} or interact with our services without signing in again.
        After you sign in, a persistent cookie stays in your browser and will be read by {WEBSITE} when you return to
        one of our sites or a partner site that uses our services. Session cookies only last for as long as the session
        (usually the current visit to a website or a browser session). <br />
        <br />
        <b>c. What are cookies used for?</b>
        <br />
        <br /> When you visit our Websites, we may place a number of cookies in your browser. These are known as First
        Party Cookies and are required to enable to hold session information as you navigate from page to page within
        the website. For example, we use cookies on our Websites to understand visitor and user preferences, improve
        their experience, and track and analyse usage, navigational and other statistical information. Additionally,
        cookies allow us to bring you advertising both on and off the {WEBSITE} site, and bring customized features to
        you. You can control the use of cookies at the individual browser level. If you elect not to activate the cookie
        or to later disable cookies, you may still visit our Websites, but your ability to use some features or areas of
        the Websites may be limited. We may use any of the following categories of cookies on the Websites as detailed
        below. Each cookie falls within one of the four following categories: <br />
        <br />
        <table>
          <thead>
            <tr>
              <th>Category</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Essential Cookies</td>
              <td>
                Essential cookies (First Party Cookies) are sometimes called "strictly necessary" as without them we
                cannot provide many services that you need on the Website. For example, essential cookies help remember
                your preferences as you move around the Website. Essential cookies also keep you logged in into a
                website. Without them the login functionality would not work.
              </td>
            </tr>
            <tr>
              <td>Analytics Cookies</td>
              <td>
                These cookies track information about visits to the {WEBSITE} and partner (recruiter websites) websites
                so that we can make improvements and report our performance. For example: analyse visitor and user
                behaviour so as to provide more relevant content or suggest certain activities. They collect information
                about how visitors use the Websites, which site the user came from, the number of each user’s visits and
                how long a user stays on the Websites. We might also use analytics cookies to test new ads, pages, or
                features to see how users react to them.
              </td>
            </tr>
            <tr>
              <td> Functionality or Preference Cookies</td>
              <td>
                During your visit to the Websites, cookies are used to remember information you have entered or choices
                you make (such as your username, language or your region) on the Websites. They also store your
                preferences when personalizing the Websites to optimize your use of {WEBSITE}. These preferences are
                remembered, through the use of the persistent cookies, and the next time you visit the Websites you will
                not have to set them again.
              </td>
            </tr>
            <tr>
              <td>Targeting or Advertising Cookies</td>
              <td>
                These Cookies are placed by third party advertising platforms or networks or {WEBSITE} in order to,
                deliver ads and track ad performance, enable advertising networks to deliver ads that may be relevant to
                you based upon your activities (this is sometimes called "behavioural" "tracking" or "targeted"
                advertising) on the Websites. They may subsequently use information about your visit to target you with
                advertising that you may be interested in, on {WEBSITE} websites or other websites. For example, these
                cookies remember which browsers have visited the websites.
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <br />
        <b>d. When does {WEBSITE} place cookies?</b>
        <br />
        <br /> We use cookies on our websites, mobile sites and mobile applications. Any browser visiting these sites
        will receive cookies from us which helps us identify you more quickly when you return. Cookies help us to
        determine which pages or information you find most useful or interesting on our own websites.
        <br />
        <br /> {WEBSITE} may also have some cookies for its own analytics i.e. analytics not part of Google Analytics.
        Such cookies help generate statistics and reports about visitors and their activities on the website or app.
        <br />
        <br />
        <b>e. How cookies are used for online analytics purposes?</b>
        <br />
        <br /> We may use web analytics services on {WEBSITE}, such as those of Google Analytics. These services help us
        analyse how users use the services, including by noting the third-party website from which you arrive. The
        information collected by the technology will be disclosed to or collected directly by such service providers,
        who use the information to evaluate your use of the services. We also use Google Analytics for certain purposes
        related to online marketing, as described in the following sections. <br />
        <br />
        <b>f. How are cookies used for advertising purposes?</b>
        <br />
        <br /> Cookies and other ad technology such as beacons, pixels, and tags help us serve relevant ads to you more
        effectively. They also help us provide aggregated auditing, research, and reporting for advertisers, understand
        and improve our service, and know when content has been shown to you. We work with website analytics and
        advertising partners, including Google Display Network, Facebook, etc. to deliver {WEBSITE}
        advertisements on third party publisher websites - these partners may set cookies on your computer's web
        browser. These cookies allow our partners to recognize your computer so that the ad server can show you{' '}
        {WEBSITE} advertisements elsewhere on the Internet, and so that our analytics software can measure your
        engagement and interactions while using {WEBSITE} services. In this way, ad servers may compile anonymous,
        de-identified information about where you, or others who are using your computer, saw our advertisements,
        whether or not you interacted with our advertisements, and actions performed on subsequent visits to {WEBSITE}{' '}
        websites and applications. This information allows an ad network to deliver targeted advertisements that they
        believe will be of most interest to you, and it allows {WEBSITE} to optimize the performance of our advertising
        campaigns and the usability of our website. In other words, we use analytics data in concert with data about our
        online ads that have been shown using the Google Display Network, Facebook for Advertisers, or other online
        advertising networks. By doing so, we can understand how anonymous users interacted with our website after
        seeing our ads. <br />
        <br />
        <b>g. What third-party cookies does {WEBSITE} use?</b>
        <br />
        <br /> Please note that the third parties (advertising networks and providers of external services like web
        traffic analysis services) may also use cookies on our Services. Cookies on our sites. Also, note that the names
        of cookies, pixels and other technologies may change over time. <br />
        <br /> We use trusted partners to help us service advertising, who may place cookies on your device. We also
        pull through content from social networks into our own pages, such as embedded Facebook feeds. The social
        networks, such as Facebook, Google, etc. may themselves also put cookies on your machine. If a user logs into
        Facebook, Twitter or Google+ via our website, they will leave a cookie on the users' computer. This is the same
        process as if the user logs into these social networks directly. <br />
        <br /> We also use Google Analytics on our Services to help us analyse how our Services are used. Google
        Analytics uses performance cookies to track customer’s interactions. For example, by using cookies, Google can
        tell us which pages our users view, which are most popular, what time of day our websites are visited, whether
        visitors have been to our websites before, what website referred the visitor to our websites, and other similar
        information. All of this information is anonymized. <br />
        <br /> We suggest that you should check the respective privacy policies for these external services to help you
        understand what data these organisations hold about you and how they process it. <br />
        <br /> Facebook:{' '}
        <a href='https://www.facebook.com/policy.php' target='_blank' rel='noreferrer'>
          https://www.facebook.com/policy.php
        </a>
        <br />
        <br /> AdSense:{' '}
        <a href='https://policies.google.com/technologies/ads' target='_blank' rel='noreferrer'>
          https://policies.google.com/technologies/ads
        </a>
        <br />
        <br /> Google Analytics:{' '}
        <a href='https://www.google.com/analytics/learn/privacy.html' target='_blank' rel='noreferrer'>
          https://www.google.com/analytics/learn/privacy.html
        </a>
        <br />
        <br /> Google Tag Manager:{' '}
        <a href='https://www.google.com/analytics/tag-manager/faq/' target='_blank' rel='noreferrer'>
          https://www.google.com/analytics/tag-manager/faq/
        </a>
        <br />
        <br /> Google+:{' '}
        <a href='https://www.google.com/policies/privacy/' target='_blank' rel='noreferrer'>
          https://www.google.com/policies/privacy/
        </a>
        <br />
        <br /> Twitter:{' '}
        <a href='https://twitter.com/en/privacy' target='_blank' rel='noreferrer'>
          https://twitter.com/en/privacy
        </a>
        <br />
        <br /> Google Double click:{' '}
        <a href='https://support.google.com/dfp_premium/answer/2839090?hl=en' target='_blank' rel='noreferrer'>
          https://support.google.com/dfp_premium/answer/2839090?hl=en
        </a>
        <br />
        <br />
        <b>h. What are Web Beacons?</b>
        <br />
        <br /> {WEBSITE} occasionally advertises on third party websites. As part of our effort to track the success of
        our advertising campaigns, we may at times use a visitor identification technology such as "web beacons," or
        "action tags," which count visitors who have come to our site after being exposed to a {WEBSITE} banner ad on a
        third party site. Our partners may also use web beacons to collect data in the aggregate as provided by your
        browser while you are on our site or another site where {WEBSITE} is third party. <br />
        <br /> By navigating on our site, you agree that we can place cookie and web beacons on your computer or device.
        If you prefer not to receive web beacons, then you should stop using our site, or consult your browsing
        settings. <br />
        <br />
        <b>i. How to control cookies?</b>
        <br />
        <br /> Most browsers allow you to control cookies through their settings preferences. However, if you choose to
        turn off these cookies, you will still see advertising on the internet but it may not be tailored to your
        interests. It does not mean that you won't be served any advertisements whilst you are online. Whilst we have
        mentioned most of the third parties involved in using targeting or advertising cookies in the preceding section
        , the list is not exhaustive and is subject to change. Therefore, even if you choose to turn off all the
        third-party cookies listed in section , you may still receive some tailored advertisements and recommendations.{' '}
        <br />
        <br /> There are a number of ways you can manage what cookies are set on your devices. Essential cookies,
        however, cannot be disabled. If you do not allow certain cookies to be installed, the website may not be
        accessible to you and/or the performance, features, or services of the website may be compromised. <br />
        <br /> You can also manage this type of cookie in the privacy settings on the web browser you are using. Please
        note that if you use your browser settings to block all cookies you may not be able to access parts of our or
        others' websites. Please see below for more information. <br />
        <br />
        <b>
          <i>Changing your Cookie Settings</i>
        </b>
        : The browser settings for changing your cookies settings are usually found in the 'options' or 'preferences'
        menu of your internet browser. In order to understand these settings, the following links may be helpful.
        Otherwise you should use the 'Help' option in your internet browser for more details. <br />
        <ul>
          <li>
            <a
              href='https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies'
              target='_blank'
              rel='noreferrer'>
              Cookie settings in Internet Explorer
            </a>
          </li>
          <li>
            <a
              href='https://support.mozilla.org/en-US/kb/enable-and-disable-cookies-website-preferences'
              target='_blank'
              rel='noreferrer'>
              Cookie settings in Firefox
            </a>
          </li>
          <li>
            <a href='https://support.google.com/chrome/answer/95647' target='_blank' rel='noreferrer'>
              Cookie settings in Chrome
            </a>
          </li>
          <li>
            <a href='https://support.apple.com/en-in/guide/safari/sfri11471/mac' target='_blank' rel='noreferrer'>
              Cookie settings in Safari
            </a>
          </li>
        </ul>
        <b>
          <i>More information</i>
        </b>
        : To find out more about cookies, including how to see what cookies have been set and how to manage and delete
        them, visit{' '}
        <a href='https://www.allaboutcookies.org' target='_blank' rel='noreferrer'>
          www.allaboutcookies.org
        </a>
        . You can learn more about opting out of receiving interest-based ads from other companies at{' '}
        <a href='https://optout.aboutads.info' target='_blank' rel='noreferrer'>
          optout.aboutads.info
        </a>{' '}
        and{' '}
        <a href='https://www.networkadvertising.org/choices' target='_blank' rel='noreferrer'>
          www.networkadvertising.org/choices
        </a>
        . In addition, certain third party advertising networks, like Facebook (pixels) and Google, permit users to opt
        out of or customize preferences associated with your internet browsing. To learn more about this feature from
        Google, click here. For further information about the Facebook Pixel, click
        <a href='https://www.facebook.com/business/help/651294705016616' target='_blank' rel='noreferrer'>
          here
        </a>
        .
      </div>
    </Card>
  )

  const RefundsPolicy = (
    <Card bodyStyle={{ height: 700 }}>
      <p>
        Our focus is complete customer satisfaction. In the event, if you are displeased with the services provided, we
        will refund back the money, provided the reasons are genuine and proved after investigation. Please read the
        fine prints of each deal before buying it, it provides all the details about the services or the product you
        purchase.
      </p>
      <p>
        In case of dissatisfaction from our services, clients have the liberty to cancel their projects and request a
        refund from us. Our Policy for the cancellation and refund will be as follows:
      </p>
      <div>
        <h3> Cancellation Policy</h3>
        <p>For Cancellations please contact the us via contact us link. </p>
        <p>
          Requests received later than 3 business days prior to the end of the current service period will be treated as
          cancellation of services for the next service period.
        </p>
      </div>
      <div>
        <h3>Refund Policy</h3>
        <p>We will try our best to create the suitable design concepts for our clients.</p>
        <p>In case any client is not completely satisfied with our products we can provide a refund. </p>
        <p>
          If paid by credit card, refunds will be issued to the original credit card provided at the time of purchase
          and in case of payment gateway name payments refund will be made to the same account.
        </p>
      </div>
    </Card>
  )

  const handleOkAndCancel = () => {
    setShowTNC(false)
    document.getElementById('tnc').scrollTo(0, 0)
  }

  return (
    <Modal
      width={1700}
      bodyStyle={{ height: '60vh', overflowY: 'scroll' }}
      title={
        type === 't&c'
          ? 'Terms and Conditions'
          : type === 'privacy'
          ? 'Privacy Policy'
          : type === 'refunds'
          ? 'Refunds & Cancellation Policy'
          : ''
      }
      open={showTNC}
      onOk={handleOkAndCancel}
      onCancel={handleOkAndCancel}
      closeIcon={<AiFillCloseCircle size='var(--modal-close-icon-size)' />}
      footer={[<Button label={'Close'} key='cancel' type='primary' handleClick={handleOkAndCancel} />]}>
      <div id='tnc' className={styles.TermsAndConditions}>
        {type === 't&c' && TermsAndConditions}
        {type === 'privacy' && PrivacyPolicy}
        {type === 'refunds' && RefundsPolicy}
      </div>
    </Modal>
  )
}
